// extracted by mini-css-extract-plugin
export default {"top-section":"_ts7avn","topSection":"_ts7avn","app-icon":"_sekoan","appIcon":"_sekoan","wix-offering-icon":"_1exe3vj","wixOfferingIcon":"_1exe3vj"};